import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import intlShape from '@/shared/utils/intlShape';
import OkCancelModal from '@/shared/components/OkCancelModal';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import messages from './taskMessages';

export default class ResetDeadlineModal extends Component {
  state = {
    selectedOption: '1',
    showValidation: false,
  };

  constructor(props) {
    super(props);

    const { intl, subtasks } = props;

    this.state.options = [
      { key: '1', label: intl.formatMessage(messages.MainTaskAndAllSubtasks) },
      { key: '2', label: intl.formatMessage(messages.OnlyMainTask) },
      ...subtasks.map(x => ({
        key: `3;${x.id}`,
        label: intl.formatMessage(listItemMsg('taskTemplate', x.id, x.name)),
      })),
    ];
    this.form = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const { show } = this.props;

    if (prevProps.show !== show) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState(() => ({
        showValidation: false,
        selectedOption: '1',
      }));
    }
  }

  static propTypes = {
    subtasks: PropTypes.arrayOf(
      PropTypes.shape({ id: PropTypes.string.isRequired, name: PropTypes.string }),
    ).isRequired,
    onSave: PropTypes.func.isRequired,
    intl: intlShape.isRequired,
    onClose: PropTypes.func.isRequired,
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
  };

  closeModal = () => {
    const { onClose } = this.props;
    onClose();
  };

  validate() {
    if (!this.form || !this.form.current) return false;
    const { selectedOption } = this.state;
    if (!selectedOption) return false;

    return this.form.current.reportValidity();
  }

  optionChanged = event => {
    this.setState({
      selectedOption: event.target.value,
    });
  };
  onSave = () => {
    const { selectedOption } = this.state;
    const { onSave } = this.props;
    if (!this.validate()) return Promise.reject(new Error('invalid form'));

    const [type, subtaskTemplateId = null] = selectedOption.split(';');

    const parameters = {
      recalcSubtasks: type === '1',
      subtaskTemplateId,
    };

    return onSave(parameters);
  };

  render() {
    const { show, intl } = this.props;
    const { options, selectedOption, showValidation } = this.state;
    const [type, subtaskTemplateId = null] = selectedOption.split(';');

    return (
      <OkCancelModal
        title={intl.formatMessage(messages.ResetDeadline)}
        show={show}
        onClose={this.closeModal}
        disabled={showValidation && !this.validate()}
        onSave={this.onSave}
        onHoverSave={() => this.setState({ showValidation: true })}
      >
        {show && (
          <form ref={this.form}>
            <div className="form-horizontal">
              <div
                className={classNames('form-group', {
                  'has-error': showValidation && !selectedOption,
                })}
              >
                <label className="control-label col-sm-3">
                  {intl.formatMessage(messages.UpdateFor)}
                </label>
                <div className="col-md-6">
                  {options && (
                    <select
                      onChange={this.optionChanged}
                      className="form-control form-field"
                      value={selectedOption || ''}
                    >
                      {options.map(({ key, label }) => (
                        <option key={key} value={key}>
                          {label}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              </div>
              <div className="alert alert-info">
                <FormattedMessage
                  {...(type === '3'
                    ? messages.SubTaskDeadlineResetInfo
                    : messages.MainTaskDeadlineResetInfo)}
                />
              </div>
            </div>
          </form>
        )}
      </OkCancelModal>
    );
  }
}
